import React from 'react'
import { MenuButton } from '@arnsbogroup/react-voicearchive'
import { Menu } from '@headlessui/react'
import { useIntl } from 'react-intl'
import messages from './messages'

const CreateDeal = ({ order, readOnly }) => {
  const { formatMessage } = useIntl()

  const onClick = () => {
    fetch(`/order/syncDeal.json?orderId=${order.uid}`, { 
      method: 'POST'
    }) 
    .then((response) => response.json())
    .then((response) => {
      if (response.success) {
        toastr.success(formatMessage(messages.createDealSuccess))
      } else {
        toastr.error(formatMessage(messages.createDealError))
      }
    })
    .catch((error) => toastr.error(error))
  }

  return (
    <Menu.Item key='createDeal' disabled={readOnly}>
      {(props) => (
        <MenuButton disabled={readOnly} {...props} onClick={onClick}>
          { order.deal_id ? formatMessage(messages.createDeal) : formatMessage(messages.syncDeal) }
        </MenuButton>
      )}
    </Menu.Item>
  )
}

export default CreateDeal
